import { clearUserSessionStores } from "@/lib/store-utils"
import { authStore } from "@/store/auth"

import { authService } from "../services/authService"
import { OrganizationAccessScope } from "../types"

export async function switchToOrganization(
  organizationId: string,
  accessScope: OrganizationAccessScope
): Promise<void> {
  const response = await authService.switchOrganization(organizationId)

  authStore.setState({
    user: { ...response.user, active_organization_scope: accessScope },
    token: response.access_token,
    refreshToken: response.refresh_token,
    tokenType: response.token_type,
    isLoading: false,
    isAuthenticated: true,
  })

  clearUserSessionStores()

  // Full reload so every store, query cache and realtime connection restarts
  // under the new organization context.
  window.location.assign(accessScope === "crm" ? "/leads" : "/dashboard")
}
